import React, { Component } from "react"
import classNames from "classnames"

import Html from "./html.jsx"

import styles from "./table-header.less"

const nop = () => {} // to prevent errors when children call it

class SimpleHeader extends Component {
  mapChildren(children) {
    return React.Children.toArray(children)
      .filter(React.isValidElement)
      .map((item) => {
        return React.cloneElement(item, {
          setHeaderScrollPosition: nop,
          setHeaderColumnsWidth: nop,
          displayFixed: true,
          columnsWidth: [],
          fixedHeaderNode: null,
          fixed: false,
        })
      })
  }

  render() {
    const { children, htmlType } = this.props
    const className = classNames(styles.thead, this.props.className, "rs_skip")

    return (
      <Html type={htmlType} className={className}>
        {this.mapChildren(children)}
      </Html>
    )
  }
}

export default SimpleHeader
